import { useT } from "../i18n/LocaleProvider";

// Tour T-9 (owner, 20 October 2026): the wordmark and tagline above every public
// card, so somebody arriving from an email knows where they are.
// Tour T-10: on a page that belongs to an agency (its application link), the
// agency's name leads instead, and Verbunk is a line at the foot — `PoweredBy`.
export function BrandMark({ agency }: { agency?: string }) {
  const { t } = useT();
  if (agency) {
    return (
      <header className="brand-mark">
        <span className="brand-mark-word">{agency}</span>
      </header>
    );
  }
  return (
    <header className="brand-mark">
      <span className="brand-mark-word">Verbunk</span>
      <span className="brand-mark-tagline">{t("The crew behind every event")}</span>
    </header>
  );
}

export function PoweredBy() {
  const { t } = useT();
  return <p className="brand-mark-foot">{t("Powered by Verbunk")}</p>;
}
